/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rupee-error': {
    width: 8,
    height: 10,
    viewBox: '0 0 8 10',
    data: '<g _stroke="#F66" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M1.477.542h5.36M2.27 2.846h4.507M5.515 9.194L1.793 5.053c.823 0 1.71.064 2.474-.305.614-.297 1.155-.9 1.185-1.607.042-.989-.478-2.239-1.92-2.6H2.379"/></g>'
  }
})
